import {
  SIGNUP_SUCCESS_RESPONSE,
  SIGNUP_ERROR,
  SIGNUP_LOADING,
} from "../actions/SignupActions";

const initialState = {
  success: false,
  loading: false,
  error: {
    username: null,
    password: null
  }
};

const SignupReducer = function(state = initialState, action) {
  switch (action.type) {
    case SIGNUP_LOADING: {
      return {
        ...state,
        loading: true
      };
    }
    case SIGNUP_SUCCESS_RESPONSE: {
      return {
        ...state,
        success: true,
        loading: false
      };
    }

    case SIGNUP_ERROR: {
      return {
        success: false,
        loading: false,
        error: action.payload,
 
      };
    }
    default: {
      return state;
    }
  }
};

export default SignupReducer;
